import React from "react"
import { Link } from "gatsby"
import { css, jsx } from "@emotion/core"

function QuickLinkMenu(props) {
  const links = props.links
  const linkItems = links.map(link => (
    <li
      key={link.to.toString()}
      css={{
        listStyle: "none",
      }}
    >
      <Link
        css={{
          display: "inline-block",
          width: "100%",
          borderBottom: "1px solid #abadb3",
          textTransform: "capitalize",
          padding: "12px 30px",
          textDecoration: "none",
          color: "#abadb3",
          "&:hover": {
            backgroundColor: "#f7f8fa",
          },
        }}
        to={link.to}
        activeStyle={{ color: "rgb(9, 37, 86)" }}
        partiallyActive={true}
      >
        {link.text}
      </Link>
    </li>
  ))

  return (
    <div
      css={{
        backgroundColor: "#fff",
        boxShadow: "0px 2px 9px -4px #383838",
        marginBottom: "3rem",
      }}
    >
      <div
        css={{
          padding: "15px 25px",
          borderBottom: "1px solid #919399",
        }}
      >
        <h3>{props.title}</h3>
      </div>
      <ul>{linkItems}</ul>
    </div>
  )
}

export default QuickLinkMenu
